export default __webpack_public_path__ + "static/media/accesories.eeae5824.webp";